import { useState } from 'react';
import { ShowUpImg } from "./ShowUpImg.client";

export function ZoomUpImg(props) {

  const [isModalShown, setIsModalShown] = useState<boolean>(false);

  return (
    props.scrollRef ? (
      <>
        <ShowUpImg
          src={props.src}
          scrollRef={props.scrollRef}
          setIsModalShown={setIsModalShown}
        />
        <div
          className={ (isModalShown ? 'shown' : '') + ' modal-wrapper'}
          onClick={() => setIsModalShown(false)}
        >
          <img src={props.src}/>
        </div>
      </>
    ) : (
      <>
        <img src={props.src} className={props.className} onClick={() => {
          setIsModalShown(true)
        }}/>
        <div
          className={ (isModalShown ? 'shown' : '') + ' modal-wrapper'}
          onClick={() => setIsModalShown(false)}
        >
          <img src={props.src}/>
        </div>
      </>
    )
  )
}